export function getCookie(name: string) {
  return (
    document.cookie
      .split(';')
      .map((cookie) => cookie.trim())
      .find((cookie) => cookie.startsWith(name))
      ?.split('=')[1] || null
  );
}
export function getExactCookie(name: string) {
  const cookie = document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(name + '='));

  if (!cookie) {
    return null;
  }

  return cookie.substring(name.length + 1) || null;
}
export function setCookie(name: string, value: string | null, days: number) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = name + '=' + value + '; ' + expires + '; path=/; domain=' + `.${import.meta.env.VITE_COOKIES_SITE_URL}`;
}

export function deleteCookie(name: string) {
  const domains = [`.${import.meta.env.VITE_COOKIES_SITE_URL}`];

  domains.forEach(domain => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`;
  });
}
